<template>
  <div class="highlight-wrap">
    <div
      v-on-display="{ sectionInfo, context: this }"
      class="multi highlight-band"
      :style="`background-image:url(${bgImageLandscape});background-color:${bgColor}`"
    >
      <div class="highlight-band-meta">
        <h1 tabindex="0" class="highlight-band-txt">
          <em v-if="logoImage" class="logo-image">
            <img :src="logoImage" :alt="`${mainTitleA} ${mainTitleB}`" />
          </em>
          <em v-else>
            <span v-if="hasMainTitleA">{{ mainTitleA }}</span>
            <span v-if="hasMainTitleB">{{ mainTitleB }}</span>
          </em>
        </h1>
        <div class="highlight-band-subtitle">
          <p v-if="hasSubTitle" v-html="subTitle"></p>
        </div>
        <a
          href="#"
          class="highlight-band-more"
          @click.prevent="viewMore(sectionInfo)"
          >{{ cta }}</a
        >
      </div>
      <div class="highlight-band-multi">
        <CellList
          v-if="cellList.length > 0"
          :cell-list="cellList"
          :thumbnail-info="thumbnailInfo"
          cell-type="band_highlight"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import { ref, computed } from 'vue'
  import { onDisplay } from '@/common/resources/directives'
  import MultiSectionMixin from '@/mixins/multisection.mixin'
  import CellList from '@/components/band/CellList.vue'
  import { resizeThumbnail } from '@/common/utils/image'
  import { convertBand } from '@/common/converter/convert-band'

  export default {
    components: {
      CellList,
    },
    directives: {
      onDisplay,
    },
    mixins: [MultiSectionMixin],
    props: {
      catalogInfo: {
        type: Object,
        default: () => {},
      },
      sectionInfo: {
        type: Object,
        default: () => {},
      },
      thumbnailInfo: {
        type: Object,
        default: () => {},
      },
    },
    setup(props) {
      const band = ref({})
      const cellList = ref([])
      const cta = ref('더보기')
      const titleList = ref([])
      const bandInfo = ref({})
      const cellTopList = ref({})
      const bgImageLandscape = ref('')
      const bgColor = ref('')
      const logoImage = ref('')
      const mainTitleA = ref('')
      const mainTitleB = ref('')
      const subTitle = ref('')

      const hasMainTitleA = computed(() => mainTitleA.value !== '')
      const hasMainTitleB = computed(() => mainTitleB.value !== '')
      const hasSubTitle = computed(() => subTitle.value !== '')

      const setTitle = (titleList) => {
        const [titleA, titleB, subtitle] = titleList.map((title) => title?.text)
        mainTitleA.value = titleA ?? ''
        mainTitleB.value = titleB ?? ''
        subTitle.value = subtitle
      }

      const setData = async () => {
        try {
          band.value = await convertBand(props.catalogInfo)
          bandInfo.value = band.value?.band ?? {}
          cellList.value = band.value?.band?.celllist ?? []
          cellTopList.value = band.value?.cell_toplist ?? {}
          cta.value = cellTopList.value?.cta || '더보기'
          titleList.value = cellTopList.value?.title_list ?? []
          logoImage.value = cellTopList.value?.logoImage ?? ''
          bgImageLandscape.value = resizeThumbnail(
            cellTopList.value?.bgImageLandscape ?? '',
            {
              height: 444,
            },
          )
          bgColor.value = cellTopList.value?.bgColor ?? ''
          setTitle(titleList.value)
        } catch (e) {
          console.log('error', e.message)
        }
      }

      setData()

      return {
        cellList,
        cta,
        titleList,
        bandInfo,
        cellTopList,
        bgImageLandscape,
        bgColor,
        logoImage,
        blur,
        mainTitleA,
        mainTitleB,
        subTitle,
        hasMainTitleA,
        hasMainTitleB,
        hasSubTitle,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .highlight-wrap {
    padding: 0 100px 80px;
    .multi.highlight-band {
      width: 100%;
      margin: 0;
      .highlight-band-meta {
        max-width: inherit;
        width: 380px;
        flex: none;
      }
      .highlight-band-multi {
        flex: 1;
        margin-left: 60px;
      }
      .swiper-container {
        min-width: inherit;
        min-height: inherit;
        padding: 0 60px 0 0;
        &:after,
        &:before {
          display: none;
        }
      }
    }
  }

  .logo-image {
    display: block;
    width: 300px;
    height: 104px;
    img {
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
    &::before {
      display: inline-block;
      width: 1px;
      height: 100%;
      margin-left: -1px;
      vertical-align: middle;
      content: '';
    }
  }
</style>
